export const validEmail = new RegExp(
  "^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$"
);

export const validName = new RegExp("^[a-zA-Z]+ ([a-zA-Z]).{1,}$");

export const validMessage = new RegExp("^([a-zA-Z0-9._:$!%-]).{10,200}$");
